// src/redux/procsSlice.ts
// 工場・加工・機械のマスタデータ
import { createSlice} from '@reduxjs/toolkit';
import apiAxios from '../utils/apiAxios';
import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice";


type Notification = {
  id: string;
  message: string;
  po_desces: string[];
};

type Notifications = {
  values : Notification[];
}

// 初期値
const initialState : Notifications = {
  values : []
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState, 
  reducers: {
    setNotifications: (state, {type, payload}) => {
      state.values = payload;
    },
  },
});

const {setNotifications} = notificationsSlice.actions;

// 通知一覧の取得 thunkパターン
const fetchNotifications = (plant_code:String, proc_code:String, mach_codes:String[]) => {
  return async (dispatch:Dispatch<AnyAction>) => {
    if (mach_codes.length === 1 && plant_code !== "" && proc_code !== "" && mach_codes[0] !== "") {
      try {
        // 機械が1件取得されている場合に通知一覧を取得する
        const response = await apiAxios.get(
          `/notifications?plant_code=${plant_code}&proc_code=${proc_code}&mach_code=${mach_codes[0]}`);
        const data = response.data;
        dispatch(setNotifications(data));
      }  catch (error:any) {
        console.error(error);
        dispatch(appendAlert({
          severity:"error",
          message:"データの取得に失敗しました。" + error.message,
          displayTime: 5000
        },));
      }
    } else {
      // 機械が選択されていない、または複数選択されている場合は通知を取得しない
      dispatch(setNotifications([]));
    }
  }
}

export {setNotifications, fetchNotifications}
export default notificationsSlice.reducer;
